<template>
    <div class="flex flex_column text_left">
        <div class="flex flex_between gray_very_light_background_color">
            <span class="font_bold" style="margin: 5px">
                {{action.title}}
            </span>
            <el-tooltip placement="top"
                        :content="disabledReason"
                        :disabled="!disabled"
            >
                <md-switch style="margin: 5px"
                           v-model="granted"
                           :disabled="disabled"
                ></md-switch>
            </el-tooltip>
        </div>
        <p class="secondary_color" style="margin: 0 5px">
            {{action.description}}
        </p>
        <div v-if="$slots.default" v-show="granted" class="border_grey" style="padding: 5px; margin-top: 5px; margin-right: 5px;">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        action: { type: Object, default: null },
		isFromCompany: { type: Boolean, default: null },
        isFromRole: { type: Boolean, default: false },
        canEdit: { type: Boolean, default: false },
        granted: { type: Boolean, default: false },
    },
    computed: {
        id() {
            return this.action.id;
        },
        disabled() {
            return this.isFromCompany || this.isFromRole || !this.canEdit;
        },
        disabledReason() {
            if (this.isFromCompany || this.isFromRole) {
                return this.$t('manageUser.permissions.actions.changeNotAllowed.isPartOfRole');
            } else if (!this.canEdit) {
                return this.$t('manageUser.permissions.actions.changeNotAllowed.missingPermission');
            }

            return "";
        },
    }
};
</script>